'use client';

import Image from '@/components/image';
// import { banner_event } from '@/utils/gtm';
import { useTranslations } from 'next-intl';
import PlusIcon from '@/components/icons/plus';
import NextLink from '@/components/next-link';
import { event_select_promotion } from '@/utils/gtm';

const BannerWithTextCard = ({
  info,
  isMobile,
  locale,
  isThree,
  index,
  totalLength,
  ref,
  sliderKey,
  position,
}) => {
  const t = useTranslations('');
  const spanClass =
    isThree && index === totalLength - 1 ? 'col-span-2' : 'col-span-1';
  const src = isMobile
    ? info?.[`mobile-img-${locale}`]
    : info?.[`img-${locale}`];
  const href = info?.url ? `/${info?.url}` : '#';
  return (
    <div
      className={`relative h-38 w-full overflow-hidden rounded-lg sm:h-46 md:h-60 lg:h-[282px] ${spanClass}`}
    >
      <Image
        loading='lazy'
        src={src}
        className='h-full w-full rounded-lg object-cover'
        alt={info?.[`alt-${locale}`] || 'Banner Img!'}
      />

      {/* Overlay */}
      <div
        className={`absolute inset-0 ${totalLength !== 2 ? 'bg-black/50' : 'bg-black/25'}`}
      />

      {/* Text Content */}
      <div className='absolute top-0 z-50 px-5 py-8 text-white max-sm:ps-2 md:p-10'>
        <p className='text-[9px] sm:text-[13px]'>{info?.[`title-${locale}`]}</p>
        <p className='mt-2 w-3/4 text-[11px] font-semibold sm:text-base md:mt-4.5 md:w-2/3 md:text-lg'>
          {info?.[`description-${locale}`]}
        </p>
      </div>

      {/* View Collections (Bottom Aligned) */}
      <NextLink
        href={href}
        ref={ref}
        onClick={() =>
          event_select_promotion({
            promotionImage: info?.[`img-${locale}`],
            key: sliderKey,
            position: position,
            id: info?.id,
            name: info?.[`title-${locale}`],
            url: href,
          })
        }
        className={`absolute bottom-5 flex items-center gap-2 text-white md:bottom-10 ${locale === 'en' ? 'left-5 max-sm:left-2 md:left-10' : 'right-5 max-sm:right-2 md:right-10'}`}
      >
        <span className='flex size-4.5 items-center justify-center rounded-full bg-[#e53e3e26] md:size-9'>
          <PlusIcon className='w-3 max-sm:w-2' />
        </span>
        <span className='font-medium max-sm:text-[11px]'>
          {t('common.view_collections')}
        </span>
      </NextLink>
    </div>
  );
};

export default BannerWithTextCard;
